import { Paper } from '@mui/material';

const AssessmentContainerLayout = ({ children }) => {
  return (
    <Paper
      elevation={2}
      square={false}
      sx={{ padding: '10px', margin: '10px', width: '100%', height: '100%' }}
    >
      {children}
    </Paper>
  );
};

export default AssessmentContainerLayout;
